import { render, staticRenderFns } from "./MFormBase.vue?vue&type=template&id=da50977c&"
import script from "./MFormBase.vue?vue&type=script&lang=js&"
export * from "./MFormBase.vue?vue&type=script&lang=js&"
import style0 from "./MFormBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da50977c')) {
      api.createRecord('da50977c', component.options)
    } else {
      api.reload('da50977c', component.options)
    }
    module.hot.accept("./MFormBase.vue?vue&type=template&id=da50977c&", function () {
      api.rerender('da50977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MFormBase.vue"
export default component.exports